/**
 * B-new-870 (LSSI-CE Art. 21.2) — lifecycle-email opt-out, applied on ANY
 * authenticated landing, not just `/dashboard/overview`.
 *
 * Since B-new-887 (21d7218b5), every marketing CTA sends new visitors to
 * `/{locale}/sign-up?redirect=/{locale}/jobs?...`, so most new accounts land
 * on `/jobs`, not `/dashboard/overview`. Placing this logic on a single
 * route component missed the majority of real sign-ups. It now lives in
 * `AuthProvider` (`apps/web/src/lib/auth-context.tsx`), which every
 * authenticated route renders, and is applied exactly once per session via
 * a ref guard there.
 *
 * Cross-device-authoritative source is the `lcOptOut=1` query param carried
 * on the magic-link callback URL (see `sign-up.lazy.tsx`'s
 * `buildMagicLinkCallbackUrl`) — it works when the link is opened on a
 * different device than the one used to sign up. `sessionStorage` is a
 * same-device-only fallback for whatever reason the param might be absent.
 *
 * Pure functions — no DOM access beyond the strings passed in — for direct
 * unit testing without rendering the provider tree.
 */

/** True if the current landing should apply the lifecycle-email opt-out. */
export function shouldApplyLifecycleEmailOptOut(opts: {
  search: string
  sessionStorageValue: string | null
}): boolean {
  const params = new URLSearchParams(opts.search)
  if (params.get('lcOptOut') === '1') return true
  return opts.sessionStorageValue === '1'
}

/** Strips `lcOptOut` from a query string, preserving every other param
 *  (e.g. `country=DE&q=...` on `/jobs`, or `redirect=` on `/dashboard/overview`). */
export function stripLifecycleOptOutParam(pathname: string, search: string): string {
  const params = new URLSearchParams(search)
  if (!params.has('lcOptOut')) return `${pathname}${search}`
  params.delete('lcOptOut')
  return params.toString() ? `${pathname}?${params}` : pathname
}
